<template>
  <div class="creat-subject-wrapper">
    <!-- 顶部栏 -->
    <div class="top-bar">
      <div class="top-title">自测选题</div>
      <div class="top-actions">
        <el-button @click="handleClose">关闭</el-button>
        <el-button type="primary" @click="handleTest">测试</el-button>
      </div>
    </div>

    <!-- 主体区域：左右分栏 -->
    <div class="main-container">
      <!-- 左侧面板：表单 -->
      <div class="left-panel">
        <el-form
          :model="formData"
          :rules="rules"
          ref="formRef"
          label-position="top"
        >
          <el-form-item label="选择科目" prop="value">
            <el-select
              v-model="formData.value"
              placeholder="请选择自测科目"
              style="width: 100%"
              @change="onSubjectChange"
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.catalog"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="题目数量" prop="input">
            <el-input
              v-model="formData.input"
              placeholder="请输入题目数量 (最大60)"
              maxlength="2"
              clearable
              @input="formData.input = formData.input.replace(/[^\d]/g, '')"
              @change="mxNum(formData.input)"
            >
              <template slot="append">道</template>
            </el-input>
          </el-form-item>

          <el-form-item label="难度比例 (总和需为100%)" prop="numListValue1">
            <div class="difficulty-weight-box">
              <div class="weight-item">
                <span class="weight-label">简单</span>
                <el-select
                  v-model="formData.numListValue1"
                  placeholder="%"
                  :disabled="isDisable1"
                  @change="indexList(formData.numListValue1)"
                  @focus="focusEvent()"
                >
                  <el-option
                    v-for="item in numList"
                    :key="item.numListValue"
                    :label="item.label"
                    :value="item.numListValue"
                    :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </div>
              <div class="weight-item">
                <span class="weight-label">中等</span>
                <el-select
                  v-model="formData.numListValue2"
                  placeholder="%"
                  :disabled="isDisable2"
                  @change="indexList(formData.numListValue2)"
                  @focus="focusEvent()"
                >
                  <el-option
                    v-for="item in numList"
                    :key="item.numListValue"
                    :label="item.label"
                    :value="item.numListValue"
                    :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </div>
              <div class="weight-item">
                <span class="weight-label">困难</span>
                <el-select
                  v-model="formData.numListValue3"
                  placeholder="%"
                  :disabled="isDisable3"
                  @change="indexList(formData.numListValue3)"
                  @focus="focusEvent()"
                >
                  <el-option
                    v-for="item in numList"
                    :key="item.numListValue"
                    :label="item.label"
                    :value="item.numListValue"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div
              v-if="difficultySum !== 100 && difficultySum > 0"
              class="weight-tip"
            >
              当前总和: {{ difficultySum }}%
            </div>
          </el-form-item>

          <div class="form-btn-row">
            <el-button style="flex: 1" @click="resetForm">重置</el-button>
            <el-button style="flex: 1" type="primary" @click="confirmForm"
              >确定</el-button
            >
          </div>
        </el-form>
      </div>

      <!-- 右侧面板：章节和题型选择 -->
      <div class="right-panel">
        <el-collapse v-model="activeNames">
          <el-collapse-item title="所有章节" name="1">
            <div v-if="!formData.value" class="empty-tip">
              请先在左侧选择科目
            </div>
            <div v-else-if="chapterList.length === 0" class="empty-tip">
              请填写左侧表单并点击「确定」加载章节
            </div>
            <el-button
              v-for="(item, i) in chapterList"
              :key="i"
              class="chapter-btn"
              :class="item.id == selectedChapterId ? 'active' : ''"
              @click="goKnowledge(item.id)"
              >{{ item.chapter }}</el-button
            >
          </el-collapse-item>

          <el-collapse-item title="题型选择" name="3">
            <div v-if="!checkboxShow" class="empty-tip">请先选择章节</div>
            <div
              v-for="(idx, index) in knowledgeList"
              :key="index"
              :serialnumber="idx.serialnumber"
            >
              <el-checkbox-group
                v-if="checkboxShow"
                v-model="slectType[idx.id - 1].dataList"
                class="knowledgeGroup"
              >
                <el-tag type="warning" effect="dark" class="knowledgeTitle">{{
                  index + 1 + idx.knowledge
                }}</el-tag>
                <el-checkbox
                  v-for="(item, i) in selquestiontype[index].datas"
                  :key="i"
                  :label="item.subjectType"
                  :value="item.checked"
                  :disabled="item.disabled"
                  border
                  >{{ item.type }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken } from "@/util/session";
import {
  getCoursesAll,
  getChapterPageList,
  mathsGetMathsPageList,
  getQuestionCountList,
  getTempQuestionList
} from "@/api/student";

export default {
  name: "CreatSubject",
  data() {
    return {
      // 科目与表单
      options: [],
      serialNumber: 0,
      formData: {
        value: "",
        input: "",
        numListValue1: "",
        numListValue2: "",
        numListValue3: ""
      },
      rules: {
        value: [{ required: true, message: "请选择科目", trigger: "change" }],
        input: [{ required: true, message: "请输入题目数量", trigger: "blur" }],
        numListValue1: [
          {
            required: true,
            validator: (rule, value, callback) => {
              let { numListValue2, numListValue3 } = this.formData;
              if (!value && !numListValue2 && !numListValue3) {
                return callback(new Error("请选择难度比例"));
              }
              if (value === 0 || numListValue2 === 0 || numListValue3 === 0) {
                return callback();
              }
              if (!value || !numListValue2 || !numListValue3) {
                return callback(new Error("请完整选择三项难度比例"));
              }
              return callback();
            },
            trigger: "blur"
          }
        ]
      },
      isDisable1: false,
      isDisable2: false,
      isDisable3: false,
      list: [],
      numList: [
        { numListValue: 0, label: 0 },
        { numListValue: 10, label: 10 },
        { numListValue: 20, label: 20 },
        { numListValue: 30, label: 30 },
        { numListValue: 40, label: 40 },
        { numListValue: 50, label: 50 },
        { numListValue: 60, label: 60 },
        { numListValue: 70, label: 70 },
        { numListValue: 80, label: 80 },
        { numListValue: 90, label: 90 },
        { numListValue: 100, label: 100 }
      ],
      // 章节与题型
      activeNames: ["1", "3"],
      chapterList: [],
      knowledgeList: [],
      selectedChapterId: null,
      typeList: [
        {
          type: "单选",
          id: "1",
          subjectType: "SingX",
          checked: false,
          disabled: true
        },
        {
          type: "多选",
          id: "2",
          subjectType: "MultX",
          checked: false,
          disabled: true
        },
        {
          type: "判断",
          id: "3",
          subjectType: "JudgX",
          checked: false,
          disabled: true
        },
        {
          type: "填空",
          id: "4",
          subjectType: "FillX",
          checked: false,
          disabled: true
        },
        {
          type: "计算",
          id: "5",
          subjectType: "AnwsX",
          checked: false,
          disabled: true
        },
        {
          type: "证明",
          id: "6",
          subjectType: "ProofX",
          checked: false,
          disabled: true
        }
      ],
      selquestiontype: [],
      slectType: [],
      loadquestioncount: [],
      checkboxShow: false,
      level: [1, 2, 3],
      questionData: []
    };
  },
  computed: {
    difficultySum() {
      const s1 = Number(this.formData.numListValue1) || 0;
      const s2 = Number(this.formData.numListValue2) || 0;
      const s3 = Number(this.formData.numListValue3) || 0;
      return s1 + s2 + s3;
    }
  },
  mounted() {
    const token = getToken();
    getCoursesAll({ token }).then(res => {
      this.options = res.data;
    });
  },
  methods: {
    onSubjectChange(id) {
      // 仅记录 serialNumber，不自动加载章节
      const selected = this.options.find(item => item.id === id);
      if (selected) {
        this.serialNumber = selected.serialnumber;
      }
      // 科目切换时清空右侧内容
      this.chapterList = [];
      this.knowledgeList = [];
      this.selectedChapterId = null;
      this.checkboxShow = false;
      this.selquestiontype = [];
      this.slectType = [];
    },
    confirmForm() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return;
        if (this.difficultySum !== 100) {
          this.$message.warning("难度比例总和需为100%");
          return;
        }
        // 验证通过后加载章节
        this.chapterList = [];
        this.knowledgeList = [];
        this.selectedChapterId = null;
        this.checkboxShow = false;
        this.selquestiontype = [];
        this.slectType = [];
        const token = getToken();
        getChapterPageList({ token, coursesId: this.formData.value }).then(
          res => {
            this.chapterList = res.data.sort((a, b) => a.id - b.id);
          }
        );
      });
    },
    goKnowledge(chapterID) {
      this.checkboxShow = false;
      this.selectedChapterId = chapterID;
      const token = getToken();
      const coursesId = this.formData.value;

      mathsGetMathsPageList({ token, chapterID, coursesId })
        .then(async res => {
          this.knowledgeList = res.data.sort((a, b) => a.id - b.id);

          let arr = this.knowledgeList.map(item => item.serialnumber);
          const examquestionquery = await getQuestionCountList({
            courseSerialnumber: this.serialNumber,
            knowledgeSerialnumbers: arr
          });
          this.loadquestioncount = examquestionquery.data;

          let knowledgeLength = this.knowledgeList.length;
          for (let i = 0; i < knowledgeLength; i++) {
            let tmpknowledge = this.knowledgeList[i];
            let fid = this.selquestiontype.findIndex(
              x => x.serialnumber === tmpknowledge.serialnumber
            );
            if (fid === -1) {
              let tmpseldata = {
                serialnumber: tmpknowledge.serialnumber,
                datas: JSON.parse(JSON.stringify(this.typeList)),
                dataList: []
              };
              let fltarr = this.loadquestioncount.filter(
                x => x.knowledgeID === tmpknowledge.serialnumber
              );
              tmpseldata.datas[0].disabled =
                fltarr.findIndex(x => x.qType === "SingX") === -1;
              tmpseldata.datas[1].disabled =
                fltarr.findIndex(x => x.qType === "MultX") === -1;
              tmpseldata.datas[2].disabled =
                fltarr.findIndex(x => x.qType === "JudgX") === -1;
              tmpseldata.datas[3].disabled =
                fltarr.findIndex(x => x.qType === "FillX") === -1;
              tmpseldata.datas[4].disabled =
                fltarr.findIndex(x => x.qType === "AnwsX") === -1;
              tmpseldata.datas[5].disabled =
                fltarr.findIndex(x => x.qType === "ProofX") === -1;
              this.selquestiontype.push(tmpseldata);
              this.slectType[tmpknowledge.id - 1] = tmpseldata;
            } else {
              let fltarr = this.loadquestioncount.filter(
                x => x.knowledgeID === tmpknowledge.serialnumber
              );
              let tmpseldata = this.selquestiontype[fid];
              tmpseldata.datas[0].disabled =
                fltarr.findIndex(x => x.qType === "SingX") === -1;
              tmpseldata.datas[1].disabled =
                fltarr.findIndex(x => x.qType === "MultX") === -1;
              tmpseldata.datas[2].disabled =
                fltarr.findIndex(x => x.qType === "JudgX") === -1;
              tmpseldata.datas[3].disabled =
                fltarr.findIndex(x => x.qType === "FillX") === -1;
              tmpseldata.datas[4].disabled =
                fltarr.findIndex(x => x.qType === "AnwsX") === -1;
              tmpseldata.datas[5].disabled =
                fltarr.findIndex(x => x.qType === "ProofX") === -1;
            }
          }
          this.checkboxShow = true;
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleTest() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return;
        if (this.difficultySum !== 100) {
          this.$message.warning("难度比例总和需为100%");
          return;
        }
        this.goTestDetil();
      });
    },
    async goTestDetil() {
      const selectedKnowledgeSet = new Set();
      const selectedTypeSet = new Set();
      this.knowledgeList.forEach(item => {
        const selected = this.slectType[item.id - 1];
        if (!selected || !Array.isArray(selected.dataList)) return;
        if (selected.dataList.length > 0) {
          selectedKnowledgeSet.add(selected.serialnumber);
          selected.dataList.forEach(type => selectedTypeSet.add(type));
        }
      });

      const selectedKnowledge = [...selectedKnowledgeSet];
      const selectedTypes = [...selectedTypeSet];
      const targetNum = parseInt(this.formData.input, 10);

      if (selectedKnowledge.length === 0) {
        this.$message("请先选择章节和题型");
        return;
      }
      if (selectedTypes.length === 0) {
        this.$message("请先选择题型");
        return;
      }
      if (!Number.isInteger(targetNum) || targetNum <= 0) {
        this.$message("题目数量无效");
        return;
      }

      const result = await getTempQuestionList({
        courseSerialnumber: this.serialNumber,
        knowledgeSerialnumbers: selectedKnowledge
      });
      const pool = Array.isArray(result.data) ? result.data : [];
      const selectedTypeLookup = new Set(selectedTypes);
      const levelLookup = new Set(this.level);

      const buckets = {};
      selectedTypes.forEach(type => {
        buckets[type] = [];
      });

      pool.forEach(item => {
        if (!item || !selectedTypeLookup.has(item.qtype)) return;
        if (!levelLookup.has(Number(item.level))) return;
        buckets[item.qtype].push(item.id);
      });

      selectedTypes.forEach(type => {
        buckets[type] = [...new Set(buckets[type])];
      });

      const totalAvailable = selectedTypes.reduce(
        (sum, type) => sum + buckets[type].length,
        0
      );
      if (totalAvailable < targetNum) {
        this.$message(`题目数量不足，最多可选 ${totalAvailable} 题`);
        return;
      }

      const selectedIds = [];
      const selectedIdSet = new Set();
      const baseCount = Math.floor(targetNum / selectedTypes.length);
      const extraCount = targetNum % selectedTypes.length;

      selectedTypes.forEach((type, index) => {
        const needCount = baseCount + (index < extraCount ? 1 : 0);
        const picked = this.getRandomArray(buckets[type], needCount);
        picked.forEach(id => {
          if (!selectedIdSet.has(id)) {
            selectedIdSet.add(id);
            selectedIds.push(id);
          }
        });
      });

      if (selectedIds.length < targetNum) {
        const restPool = [];
        selectedTypes.forEach(type => {
          buckets[type].forEach(id => {
            if (!selectedIdSet.has(id)) restPool.push(id);
          });
        });
        const restPicked = this.getRandomArray(
          [...new Set(restPool)],
          targetNum - selectedIds.length
        );
        restPicked.forEach(id => {
          if (!selectedIdSet.has(id)) {
            selectedIdSet.add(id);
            selectedIds.push(id);
          }
        });
      }

      this.questionData = selectedIds.slice(0, targetNum);

      const selectedOption = this.options.find(
        item => item.id === this.formData.value
      );
      const catalog = selectedOption ? selectedOption.catalog : "";

      const answerArr = this.questionData.map(id => ({ id: id }));
      this.$router.push({
        path: "/bistAnalysis",
        query: {
          title: catalog,
          practice: 1,
          answer: JSON.stringify(answerArr),
          catalog: catalog,
          coursesId: this.formData.value
        }
      });
    },
    getRandomNum(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    },
    getRandomArray(arr, count) {
      if (!(arr instanceof Array)) return [];
      let length = arr.length;
      let arrRes = [];
      count = length < count ? length : count;
      while (arrRes.length < count) {
        let randomIndex = this.getRandomNum(0, length - 1);
        let item = arr[randomIndex];
        if (item && arrRes.indexOf(item) < 0) {
          arrRes.push(item);
        }
      }
      return arrRes;
    },
    handleClose() {
      this.$router.push("/bist");
    },
    mxNum(num) {
      if (num > 60) {
        this.$message({ message: "最多只能选择60道题", type: "warning" });
        this.formData.input = "";
      }
    },
    indexList(num) {
      if (num === 100) {
        if (
          this.formData.numListValue1 === "" ||
          (this.formData.numListValue1 && this.formData.numListValue1 !== 100)
        ) {
          this.formData.numListValue1 = 0;
          this.isDisable1 = true;
        }
        if (
          this.formData.numListValue2 === "" ||
          (this.formData.numListValue2 && this.formData.numListValue2 !== 100)
        ) {
          this.formData.numListValue2 = 0;
          this.isDisable2 = true;
        }
        if (
          this.formData.numListValue3 === "" ||
          (this.formData.numListValue3 && this.formData.numListValue3 !== 100)
        ) {
          this.formData.numListValue3 = 0;
          this.isDisable3 = true;
        }
      } else {
        this.isDisable1 = this.isDisable2 = this.isDisable3 = false;
        this.list.unshift(num);
        this.numList = this.numList.filter(
          item => item.numListValue <= 100 - num
        );
        if (this.list.length === 2) {
          if (num !== 0) {
            this.formData.numListValue1 === ""
              ? (this.formData.numListValue1 =
                  100 - (this.list[0] + this.list[1]))
              : this.formData.numListValue1;
            this.formData.numListValue2 === ""
              ? (this.formData.numListValue2 =
                  100 - (this.list[0] + this.list[1]))
              : this.formData.numListValue2;
            this.formData.numListValue3 === ""
              ? (this.formData.numListValue3 =
                  100 - (this.list[0] + this.list[1]))
              : this.formData.numListValue3;
            let and =
              this.formData.numListValue1 +
              this.formData.numListValue2 +
              this.formData.numListValue3;
            if (and > 100) {
              this.formData.numListValue1 = "";
              this.formData.numListValue2 = "";
              this.formData.numListValue3 = "";
            }
          } else if (this.list[0] === 0) {
            this.formData.numListValue1 === ""
              ? (this.formData.numListValue1 =
                  100 - (this.list[0] + this.list[1]))
              : this.formData.numListValue1;
            this.formData.numListValue2 === ""
              ? (this.formData.numListValue2 =
                  100 - (this.list[0] + this.list[1]))
              : this.formData.numListValue2;
            this.formData.numListValue3 === ""
              ? (this.formData.numListValue3 =
                  100 - (this.list[0] + this.list[1]))
              : this.formData.numListValue3;
          } else {
            this.formData.numListValue1
              ? this.formData.numListValue1
              : (this.formData.numListValue1 =
                  100 - (this.list[0] + this.list[1]));
            this.formData.numListValue2
              ? this.formData.numListValue2
              : (this.formData.numListValue2 =
                  100 - (this.list[0] + this.list[1]));
            this.formData.numListValue3
              ? this.formData.numListValue3
              : (this.formData.numListValue3 =
                  100 - (this.list[0] + this.list[1]));
          }
          this.list = [];
          this.numList = this.$options.data().numList;
        }
      }
    },
    focusEvent() {
      if (
        this.formData.numListValue1 &&
        this.formData.numListValue2 &&
        this.formData.numListValue3
      ) {
        this.formData.numListValue1 = "";
        this.formData.numListValue2 = "";
        this.formData.numListValue3 = "";
      }
      if (
        this.formData.numListValue1 === 100 ||
        this.formData.numListValue2 === 100 ||
        this.formData.numListValue3 === 100
      ) {
        this.formData.numListValue1 = "";
        this.formData.numListValue2 = "";
        this.formData.numListValue3 = "";
      }
      if (
        this.formData.numListValue1 & this.formData.numListValue2 ||
        this.formData.numListValue1 & this.formData.numListValue3 ||
        this.formData.numListValue2 & this.formData.numListValue3
      ) {
        this.formData.numListValue1 = "";
        this.formData.numListValue2 = "";
        this.formData.numListValue3 = "";
      }
    },
    resetForm() {
      this.$refs.formRef.resetFields();
      this.list = [];
      this.numList = this.$options.data().numList;
      this.isDisable1 = false;
      this.isDisable2 = false;
      this.isDisable3 = false;
      this.serialNumber = 0;
      this.chapterList = [];
      this.knowledgeList = [];
      this.selectedChapterId = null;
      this.checkboxShow = false;
      this.selquestiontype = [];
      this.slectType = [];
    }
  }
};
</script>

<style scoped lang="scss">
.creat-subject-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f5f7fa;
}

.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 24px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  flex-shrink: 0;

  .top-title {
    font-size: 18px;
    font-weight: 800;
    color: #1e293b;
    position: relative;
    padding-left: 12px;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 18px;
      background: #2563eb;
      border-radius: 2px;
    }
  }

  .top-actions {
    display: flex;
    gap: 10px;
  }
}

.main-container {
  display: flex;
  flex: 1;
  overflow: hidden;
  gap: 16px;
  padding: 16px;
}

.left-panel {
  width: 300px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  padding: 20px;
  overflow-y: auto;

  .difficulty-weight-box {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    background: #f1f5f9;
    padding: 12px;
    border-radius: 8px;

    .weight-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 6px;

      .weight-label {
        font-size: 12px;
        color: #64748b;
        font-weight: 600;
      }

      ::v-deep .el-select {
        width: 100%;
      }
    }
  }

  .weight-tip {
    font-size: 12px;
    color: #2563eb;
    margin-top: 4px;
    text-align: right;
    font-weight: 600;
  }

  ::v-deep .el-form-item__label {
    font-weight: 700;
    color: #475569;
    padding-bottom: 6px;
    line-height: 1;
  }

  .form-btn-row {
    display: flex;
    gap: 10px;
    margin-top: 8px;
  }
}

.right-panel {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  padding: 20px;
  overflow-y: auto;

  ::v-deep .el-collapse-item__header {
    font-size: 14px;
    font-weight: bold;
    padding-left: 10px;
  }

  ::v-deep .el-tag {
    font-size: 14px;
    margin-right: 10px;
  }
}

.chapter-btn {
  margin: 4px;
  &.active {
    border-color: #2563eb;
    color: #2563eb;
  }
}

.empty-tip {
  color: #94a3b8;
  font-size: 13px;
  padding: 12px 0;
}

.knowledgeTitle {
  width: 400px;
  text-align: left;
  overflow-x: clip;
}

.knowledgeGroup {
  margin: 10px 0;
  left: 25px;
  position: relative;
  display: flex;
}
</style>
